import React from "react";

const TextoLeyPais = () => {
    return (
      <p
        style={{ backgroundColor: "rgb(232, 232, 232)", padding: "5px" }}
        className="parrafoEnMedioDePago"
      >
        La tarifa no incluye el 30 % dispuesto por el art 35 de la ley PAIS nro
        27.541. La misma se aplicara en el caso que corresponda
      </p>
    );
  }

  export default TextoLeyPais;



// WEBPACK FOOTER //
// ./src/components/ProcesoCompra/Pago/textoLeyPais.js